module.exports = __webpack_public_path__ + "ic-expand.svg?0efe21ba3f3f81bafdab6d079d451afb";